var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopperArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 12,
    viewBox: "0 0 30 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M12.1402 4.73911C9.36455 7.92807 4.86736 12 0 12H30C25.1326 12 20.6355 7.92807 17.8598 4.7391C16.4182 3.08284 13.5818 3.08284 12.1402 4.73911Z",
    fill: "#0177FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M0 11.5C4.86736 11.5 9.36455 7.42807 12.1402 4.23911C13.5818 2.58284 16.4182 2.58284 17.8598 4.2391C20.6355 7.42807 25.1326 11.5 30 11.5",
    stroke: "#0059BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopperArrow);
export default __webpack_public_path__ + "static/media/popper_arrow.03cb1904.svg";
export { ForwardRef as ReactComponent };